import * as z from 'zod';
import type { ZodOpenApiPathsObject } from 'zod-openapi';
import { problemResponse } from './common.js';

export const AuditRecordSchema = z
  .object({
    id: z.number().int(),
    entity: z.string(),
    entityId: z.string(),
    action: z.string(),
    before: z.record(z.string(), z.unknown()).nullable(),
    after: z.record(z.string(), z.unknown()).nullable(),
    userId: z.uuid().nullable(),
    reason: z.string().nullable().meta({ description: 'Why a person made a manual change' }),
    at: z.iso.datetime(),
  })
  .meta({ id: 'AuditRecord' });

export const AuditQuerySchema = z.object({
  entity: z.string().optional(),
  entityId: z.string().optional(),
  userId: z.uuid().optional(),
  from: z.iso.datetime().optional(),
  to: z.iso.datetime().optional(),
  beforeId: z.coerce.number().int().positive().optional(),
  limit: z.coerce.number().int().positive().max(200).optional(),
});

export type AuditRecordDto = z.infer<typeof AuditRecordSchema>;
export type AuditQuery = z.infer<typeof AuditQuerySchema>;

export const auditPaths: ZodOpenApiPathsObject = {
  '/api/v1/audit': {
    get: {
      summary: 'Search the audit log (newest first; page with beforeId)',
      requestParams: { query: AuditQuerySchema },
      responses: {
        '200': {
          description: 'OK',
          content: { 'application/json': { schema: z.array(AuditRecordSchema) } },
        },
        '401': problemResponse('Not signed in'),
        '403': problemResponse('Missing permission'),
      },
    },
  },
};
